import { Col, DatePicker, PageHeader, Row } from "antd";

import { Fragment, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

import TabsLayout from "../../shared/layouts/tabs.layout";
import ReportComponent from "./components/report.component";
import { API_DASHBOARD_LIST } from "../../core/route/api.routes";
import { Client } from "../../core/api-client/api-client";
const { RangePicker } = DatePicker;

function DashboardPage() {
  const [allDashboards, setAllDashboards] = useState([] as any);
  // const allDashboards = [
  //   {
  //     key: "summary",
  //     name: "Summary",
  //     data: {}
  //   },
  //   {
  //     key: "current-performance",
  //     name: "Current Performance",
  //   },
  //   {
  //     key: "current-performance",
  //     name: "Current Performance",
  //   },
  //   {
  //     key: "heirarcy-view",
  //     name: "Hierarchy View",
  //   },
  //   {
  //     key: "historic-trends",
  //     name: "Historic Trends",
  //   },
  //   {
  //     key: "leaderboard",
  //     name: "Leaderboard",
  //   },
  // ];
  var allTabs = allDashboards.map((val: any) => {
    return {
      title: <span>{val.dashboard}</span>,
      key: val.name,
      component: <><ReportComponent {...val} /></>,
    };
  });

  const onTabChange = (e: any) => {};
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  useEffect(()=>{
    getDashboardList()
  }, [])
  const getDashboardList = async () => {
    const data =  await Client.get(API_DASHBOARD_LIST);
    if(data?.data?.data){
      setAllDashboards(data?.data?.data)
    }
  }
  return (
    <Fragment>
      <PageHeader
        ghost={false}
        className={screenType.mobile ? "" : "employee"}
        title={
          <Row
            style={screenType.mobile ? { paddingLeft: "25px" } : {}}
            align="middle"
          >
            <Col flex="none" className="title-text">
              IBL Dashboard
            </Col>
          </Row>
        }
      ></PageHeader>

      <Row className="content-area">
        <Col span={24} className="crm-tabs">
          <TabsLayout AllTabs={allTabs} onChange={onTabChange}></TabsLayout>
        </Col>
      </Row>
    </Fragment>
  );
}

export default DashboardPage;
